import { Layer, Point, Line, Shape } from '../../../../context/context';
import { defaultLayer } from '../../../../context/defaults';

interface ImportTripsProps {
    global: {
        activeLayerId: number | null;
        mapLayers: Layer[];
        setLayers: (layers: Layer[] | ((prev: Layer[]) => Layer[])) => void;
        setActiveLayerId: (id: number) => void;
    };
    editLayer: (layer: Layer, layerId: number) => void;
    setShouldFitBounds: (should: boolean) => void;
}

/**
 * Handle importing trips (points and lines) into the map
 * Creates a new layer if needed or adds to existing active layer
 */
export function handleImportTrips(
    points: Point[],
    lines: Line[],
    { global, editLayer, setShouldFitBounds }: ImportTripsProps
) {
    let layerIdToUse = global.activeLayerId;
    let layers = global.mapLayers;

    // Create new layer if needed
    if (layers.length === 0 || layerIdToUse == null || layers.find(l => l.layerId === layerIdToUse) == null) {
        const newLayerId = layers.length > 0 ? Math.max(...layers.map(l => l.layerId)) + 1 : 0;
        const newLayer: Layer = {
            ...defaultLayer,
            layerId: newLayerId,
            layerName: `Imported Trip Layer ${newLayerId + 1}`,
            shapes: [...points, ...lines],
        };
        global.setLayers((prev: Layer[]) => [...prev, newLayer]);
        global.setActiveLayerId(newLayerId);
        setShouldFitBounds(true);
        return;
    }

    // Add to existing layer
    const layer: Layer = layers.find(l => l.layerId === layerIdToUse)!;
    const newShapes: Shape[] = [...layer.shapes, ...points, ...lines];
    const newLayer: Layer = {
        ...layer,
        shapes: newShapes
    };
    editLayer(newLayer, layerIdToUse);
    setShouldFitBounds(true);
} 